export default "__VITE_ASSET__DSwt0uxA__"